export default __webpack_public_path__ + "static/media/market-st-sandwich.0e056494.jpeg";